import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { MenuItem, Divider, Radio } from '@material-ui/core';
import { RouteBar, Header, Buttons } from '../../components/index';
import { POI_ACTION_TYPES, WS_ACTION_TYPES } from '../../redux-saga/actionTypes/index';
import { commands } from '../../constants/index';
import styles from './styles';

const { selectPoiCommand } = commands;
const Routes = ({
  classes,
  t,
  selectedPoi,
  routesList,
  routeListEvent,
  saveRoutesList,
  sendMessageToSocket,
  saveAlternateRoute,
  selectedRoute,
  incoming_stop,
  addStopInProgress,
}) => {
  const [selectedValue, setSelectedValue] = React.useState('');
  const handleSelectedIndex = (route, index) => {
    setSelectedValue(parseInt(index, 0));
    sendMessageToSocket(selectPoiCommand(index));
    saveAlternateRoute(route);
  };
  routeListEvent(saveRoutesList);

  return (
    <React.Fragment>
      <Header
        title={t('poi-details.label.action-button.routes')}
        subtitle={addStopInProgress ? incoming_stop.name : selectedPoi.name}
      />
      <Divider />
      <div className={classes.scroll__wheel}>
        {routesList.map((route, index) => {
          const { distance, time, routeID } = route;
          return (
            <React.Fragment key={routeID}>
              <MenuItem
                onClick={() => handleSelectedIndex(route, index)}
                className={classes.menu__wrapper}
              >
                <span className={classes.first__row}>
                  <span className={classes.minute}>{`${time}`}</span>
                  <span className={classes.mile}>{`${distance}`}</span>
                </span>
                <span className={classes.second__row}>
                  <Radio
                    checked={
                      selectedValue === index ||
                      (selectedValue === '' && selectedRoute.routeID === routeID)
                    }
                    value={index}
                    name="selected-route"
                  />
                </span>
                {distance === undefined ? (
                  ''
                ) : (
                  <span className={classes.progress__bar}>
                    <RouteBar route={route} />
                  </span>
                )}
              </MenuItem>
              <Divider />
            </React.Fragment>
          );
        })}
      </div>
      <span className={classes.footer}>
        <Buttons />
      </span>
    </React.Fragment>
  );
};

Routes.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  selectedPoi: PropTypes.object,
  routesList: PropTypes.array,
  saveRoutesList: PropTypes.func.isRequired,
  routeListEvent: PropTypes.func.isRequired,
  sendMessageToSocket: PropTypes.func.isRequired,
  saveAlternateRoute: PropTypes.func.isRequired,
  selectedRoute: PropTypes.object.isRequired,
  incoming_stop: PropTypes.object,
  addStopInProgress: PropTypes.bool,
};

Routes.defaultProps = {
  selectedPoi: {},
  routesList: [],
  incoming_stop: {},
  addStopInProgress: false,
};

const mapStateToProps = ({ poi }) => ({
  selectedPoi: poi.selected_poi,
  routesList: poi.routes_list,
  selectedRoute: poi.route,
  incoming_stop: poi.incoming_stop,
});

const mapDispatchToProps = dispatch => ({
  saveRoutesList: payload =>
    dispatch({ type: POI_ACTION_TYPES.ROUTES_LIST_FROM_WS.SUCCESS, payload }),
  routeListEvent: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_ROUTE_LIST, payload }),
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
  saveAlternateRoute: payload => dispatch({ type: POI_ACTION_TYPES.ALTERNATE_ROUTE, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(Routes)),
);
